import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { MediaTypeIcon } from '../../../../../play-core/icons/MediaTypeIcon';
import { Colors } from '../../../../../play-core/styles/Colors';
import { getBusinessUnit } from '../../../../../play-core/utils/urn-helper';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { SmartLink } from '../../ClickableComponents/SmartLink';
import { IconWrapper } from '../../IconWrapper/IconWrapper';
import { useDetailOrRedirectPath, useLivestreamOrRedirectPath } from '../../TvGuide/tv-guide-types';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgramEntryPlayLink = ({
  program,
  channel,
  analyticsPageId,
  iconSize = 22
}) => {
  const {
    t
  } = useTranslation();
  const analytics = useAnalyticsDispatch();
  const {
    businessUnit
  } = useVideoConfig();
  const detailPath = useDetailOrRedirectPath(program, channel);
  const livestreamPath = useLivestreamOrRedirectPath(program, channel);
  const path = livestreamPath || detailPath;
  const isSameBusinessUnit = !livestreamPath && program.mediaUrn ? getBusinessUnit(program.mediaUrn) === businessUnit : channel.businessUnit === businessUnit;
  return path ? /*#__PURE__*/_jsx(StyledLink, {
    to: path,
    isInternal: isSameBusinessUnit,
    tabIndex: program.tabIndex ?? -1,
    "aria-label": `${t('global.play')} - ${program.title}`,
    onKeyDown: event => event.stopPropagation(),
    onClick: event => {
      event.stopPropagation();
      const trackingEvent = livestreamPath ? {
        type: 'click-event',
        name: 'TvGuidePlayLivestream',
        value1: analyticsPageId,
        value2: channel.title
      } : {
        type: 'click-event',
        name: 'TvGuidePlayMedia',
        value1: analyticsPageId,
        value2: program.mediaUrn
      };
      analytics(trackingEvent);
    },
    children: /*#__PURE__*/_jsx(IconWrapper, {
      size: iconSize,
      icon: /*#__PURE__*/_jsx(MediaTypeIcon, {
        mediaType: "VIDEO",
        isHovering: true
      })
    })
  }) : /*#__PURE__*/_jsx(Fragment, {});
};
export const StyledLink = styled(SmartLink).withConfig({
  displayName: "ProgramEntryPlayLink__StyledLink",
  componentId: "sc-1wzplai-0"
})(["color:", ";display:flex;margin-right:8px;"], Colors.WHITE);